import React from 'react';

const Logo = ({ size = 48, className = "" }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_shipwise-39/artifacts/je700rm4_IMG_20251225_063908.jpg"
      alt="Reload Freight Logo"
      style={{ width: `${size}px`, height: `${size}px`, objectFit: 'contain' }}
      className={className}
    />
  );
};

export default Logo;
